import { LoadingOutlined } from "@ant-design/icons";
import { notification, Spin } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";

import CloseModal from "../../../components/icons/CloseModal";
import amplitude from "../../../externals/amplitude";
import { uploadToFTPValidations } from "../../../utils/validations";

const UploadToFTP = (props) => {
  const { setFTPOpen, ftpOpen, step, id, loder, clip, ftpList, ftpPublish, filters, entityId } = props;
  const [initialState, setInitialState] = useState({
    fileName: "",
    ftpName: "",
    folderPath: "",
  });
  const [channelList, setChannelList] = useState(ftpList);

  const handleSubmit = async (values) => {
    try {
      amplitude.logEvent("ftp_publish_triggered", {
        page: "clip",
      });

      const value = await ftpPublish({
        entityId,
        ftpCredentialId: values?.ftpName,
        folderPath: values?.folderPath,
        contentId: clip?._id,
        contentType: step === 1 ? "clip" : step === 2 ? "highlight" : "promo",
        fileName: values?.fileName,
        aspectRatio: filters?.aspectRatio || clip.aspectRatio,
      });

      if (value?.value?.data) {
        notification["success"]({ message: "Ftp Publish: Initiated" });
        amplitude.logEvent("ftp_published", {
          page: "clip",
        });
      } else {
        notification["error"]({ message: value?.value?.message });
        amplitude.logEvent("ftp_publish_failed", {
          page: "clip",
          error: value?.value?.message || "Failed to publish!",
        });
      }
      closeModal();
    } catch (error) {
      console.error(error);
      notification["error"]({ message: error?.error?.message || "Failed to publish!" });
    }
  };

  const closeModal = () => {
    setFTPOpen(false);
    setInitialState({
      fileName: "",
      ftpName: "",
      folderPath: "",
    });
  };

  useEffect(() => {
    setChannelList(ftpList);
  }, [ftpList]);

  return (
    <>
      <Modal
        isOpen={ftpOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Cloud Publish"
        portalClassName="react-modal"
        overlayClassName="modal"
        ariaHideApp={false}
        className="modal-dialog react-modal-dialog-sm modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">FTP Publish</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik
            initialValues={initialState}
            validationSchema={uploadToFTPValidations}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ errors, touched, setFieldValue }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container row">
                    <div className="form-group">
                      <label className="form-label">
                        FTP <span className="required">*</span>
                      </label>
                      <select
                        className="custom-select form-control"
                        name="ftpName"
                        onChange={(e) => setFieldValue("ftpName", e.target.value)}
                      >
                        <option value="default">Select FTP</option>
                        {channelList &&
                          channelList.map((data) => {
                            return (
                              <option key={data._id} value={data.id}>
                                {data.name}
                              </option>
                            );
                          })}
                      </select>
                      {touched.ftpName && errors.ftpName && <div className="invalid-feedback">{errors.ftpName}</div>}
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      Folder Path <span className="required">*</span>
                    </label>
                    <Field type="text" className="form-control" name="folderPath" placeholder="/folderpath/" />
                    {touched.folderPath && errors.folderPath && (
                      <div className="invalid-feedback">{errors.folderPath}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      File Name <span className="required">*</span>
                    </label>
                    <Field type="text" className="form-control" name="fileName" placeholder="fileName" />
                    {touched.fileName && errors.fileName && <div className="invalid-feedback">{errors.fileName}</div>}
                  </div>
                </div>
                <div className="react-modal-footer">
                  <button type="button" className="btn btn-white" onClick={closeModal}>
                    Cancel
                  </button>
                  <button className="btn btn-primary" type="submit">
                    Submit
                    {loder && (
                      <Spin
                        size="large"
                        indicator={
                          <LoadingOutlined
                            style={{
                              fontSize: 50,
                              color: "#000",
                              marginLeft: 50,
                            }}
                            spin
                          />
                        }
                        className="loader__full"
                      ></Spin>
                    )}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};

export default UploadToFTP;
